import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'upsc-term-and-conditions',
  templateUrl: './term-and-conditions.component.html',
  styleUrls: ['./term-and-conditions.component.scss']
})
export class TermAndConditionsComponent implements OnInit {

  ngOnInit(): void {
  }
}